module.exports = __webpack_public_path__ + "static/media/02.4cf14fdc.svg";